// Safe-by-default text normalization for client-side search / filter predicates.
//
// WHY THIS EXISTS
// ---------------
// Many list/search screens filter rows by calling `.toLowerCase().includes(...)`
// directly on a field the TypeScript type marks as a non-null `string`. At
// runtime those fields can still be `null` (legacy rows written before a column
// became `notNull()`) or a non-string (numbers pulled from an external provider).
// Calling a string method on `null`/a number throws
// (`Cannot read properties of null` / `x.toLowerCase is not a function`), which
// trips the React error boundary and crashes the ENTIRE list — not just the one
// bad row. This shipped as a Devices-page crash on a legacy vendor row.
//
// `searchNormalize(x)` coerces any value to a lowercased string first, so a bad
// row can never crash the search box:
//
//     rows.filter((r) => searchNormalize(r.name).includes(q))
//
// The `no-unstringified-field-search` ESLint rule recognizes both this helper and
// a bare `String(x ?? "")` wrapper as safe.
export function searchNormalize(value: unknown): string {
  return String(value ?? "").toLowerCase();
}

// True when `value`, coerced safely, contains the already-lowercased `needle`.
// Convenience wrapper for the common `searchNormalize(x).includes(q)` predicate.
export function searchIncludes(value: unknown, needle: string): boolean {
  return searchNormalize(value).includes(needle);
}
